import Vue from 'vue';

/** Event bus for sending Infrastructure events. */
const LaunchpadEventBus = new Vue();

export default LaunchpadEventBus;
